import React from 'react';

import './waves.scss';

const Waves = () => (
    <svg className="waves" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 400" role="presentation" preserveAspectRatio="xMidYMax meet">
        <g fill="#53DBD1" fillOpacity=".17">
            <path opacity=".4" d="M567.2 193.3C358 77.1 203.7 55 0 147.1V400h1440V212.1c-89.8 98.3-370.9 259.9-872.8-18.8z" />
            <path opacity=".4" d="M984.7 50.6C713.2-131.7 362.7 658.9 0 32.2V400h1440V77.1c-57.8 75.7-208.8 139.2-455.3-26.5z" />
            <path opacity=".4" d="M674.3 246.3C345.9 412.8 62.9 384.3 0 340.1V400h1440v-92.3c-146.6-102.2-462.2-215.1-765.7-61.4z" />
        </g>
    </svg>
);

export default Waves;
